import * as React from 'react';
import { st, classes } from './Badge.base.st.css';
import { BadgeBaseProps } from './types';

export class BadgeBase extends React.Component<BadgeBaseProps> {
  static displayName = 'BadgeBase';

  render() {
    const { className, children, icon, ...rest } = this.props;
    return (
      <div
        className={st(classes.root, { withIcon: !!icon }, className)}
        {...rest}
      >
        <div className={classes.innerContainer}>
          {icon && (
            <div data-hook="badge-icon" className={classes.icon}>
              {icon}
            </div>
          )}
          {children}
        </div>
      </div>
    );
  }
}
